export const feedRationFormName = 'feed-ration';

export const feedRationsPath = '/admin/feed-rations';

// Backend error keys folded into the form's "medications" error
export const medicationErrorKeys = {
  feed_ration_medications: 'medications',
  'feed_ration_medications.treatment_product': 'medications',
};

export const rawMedicationErrorKeys = Object.keys(medicationErrorKeys);
